import React from "react";
import { Quote, Sprout } from "lucide-react";
import { testimonials } from "../mock";

const Testimonials = () => {
  return (
    <section id="stories" className="bg-[#04181a] py-20 md:py-28 relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage:
            "radial-gradient(circle at 80% 20%, #14b8a6 0%, transparent 40%)",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.18em] text-teal-400 font-medium">
            Illustrative scenarios · how it could feel
          </div>
          <h2 className="mt-4 text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-white leading-[1.05]">
            What flourishing{" "}
            <em className="text-teal-300 font-serif font-normal">
              could look like.
            </em>
          </h2>
          <p className="mt-4 text-white/55 text-sm max-w-2xl">
            We&apos;re a new platform — these aren&apos;t real customers yet.
            They&apos;re honest examples of how Good Fruit is designed to feel
            for the communities we serve.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="group relative rounded-2xl overflow-hidden border border-white/10 bg-white/[0.03] hover:border-teal-400/40 hover:-translate-y-1 transition-all duration-300 p-6 flex flex-col"
            >
              <div className="flex items-center justify-between">
                <Quote className="w-7 h-7 text-teal-300/60" />
                <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wide text-teal-300/70 font-medium border border-teal-400/20 rounded-full px-2 py-0.5">
                  <Sprout className="w-2.5 h-2.5" />
                  Example
                </span>
              </div>
              <p className="mt-5 text-white/90 leading-relaxed flex-1">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="mt-6 pt-5 border-t border-white/10">
                <div className="text-white text-sm font-semibold">
                  {t.author}
                </div>
                <div className="text-white/50 text-xs mt-0.5">{t.role}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
